import styled from "styled-components";

export const WorkFlowApproverItem = styled.h5`
  padding: 12px 6px;
  font-size: 14px;
  margin: 0;

  background-color: ${({ header }) => (header ? "#f2f2f2" : "initial")};
`;
